"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config = {
    rounding: { type: '', digits: 1 },
};
exports.default = config;
//# sourceMappingURL=libConfig.js.map